import React, { useContext, useRef, useState } from "react";
import "./form_component.scss";

import * as Yup from "yup";
import emailjs from "@emailjs/browser";
import { useFormik } from "formik";
import languageContext from "../../context/languageContext";

const userIcon = require("../../assets/icons-contact/usuario.png");
const emailIcon = require("../../assets/icons-contact/email.png");
const messageIcon = require("../../assets/icons-contact/message.png");

const Form_Component = () => {
  const { language } = useContext(languageContext);

  const [formSended, setFormSended] = useState(false);

  const formRef = useRef();
  const formik = useFormik({
    initialValues: {
      user_name: "",
      user_email: "",
      message: "",
    },
    validationSchema: Yup.object({
      user_name: Yup.string()
        .required(language.formComponent.validation.required)
        .max(30, `${language.formComponent.validation.required} 30`),
      user_email: Yup.string()
        .required(language.formComponent.validation.required)
        .max(64, `${language.formComponent.validation.required} 64`)
        .email(language.formComponent.validation.email),
      message: Yup.string()
        .required(language.formComponent.validation.required)
        .max(2000, `${language.formComponent.validation.required} 2000`),
    }),
    onSubmit: (values, { resetForm }) => {
      console.log("entre", values);
      emailjs
        .sendForm(
          "service_khkaapo",
          "template_j5wm1nj",
          formRef.current,
          "e7bo1XOlWCzcNjnMO"
        )
        .then(
          (result) => {
            console.log("todo bien pa", result.text);
            resetForm();
            setFormSended(true);
            setTimeout(() => setFormSended(false), 5000);
          },
          (error) => {
            console.log("todo mal pa", error.text);
          }
        );
    },
  });
  return (
    <form
      onSubmit={formik.handleSubmit}
      className="formik-container"
      ref={formRef}
    >
      <div className="form__group">
        <label htmlFor="user_name" className="form__label">
          {language.formComponent.field1}
        </label>
        <input
          id="user_name"
          type="text"
          name="user_name"
          value={formik.values.user_name}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          className="form__field"
        />
        <img src={userIcon} alt="" className="icon-input" />
        {formik.touched.user_name && formik.errors.user_name && (
          <p className="validation-msg">{formik.errors.user_name}</p>
        )}
      </div>

      <div className="form__group field">
        <label htmlFor="user_email" className="form__label">
          {language.formComponent.field2}
        </label>
        <input
          id="user_email"
          type="email"
          name="user_email"
          value={formik.values.user_email}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          className="form__field"
        />
        <img src={emailIcon} alt="" className="icon-input" />
        {formik.touched.user_email && formik.errors.user_email && (
          <p className="validation-msg">{formik.errors.user_email}</p>
        )}
      </div>

      <div className="form__group field">
        <label htmlFor="message" className="form__label">
          {language.formComponent.field3}
        </label>
        <textarea
          id="message"
          name="message"
          value={formik.values.message}
          onBlur={formik.handleBlur}
          onChange={formik.handleChange}
          wrap="hard"
          className="form__field form__field--textarea"
        ></textarea>
        <img src={messageIcon} alt="" className="icon-input" />
        {formik.touched.message && formik.errors.message && (
          <p className="validation-msg">{formik.errors.message}</p>
        )}
      </div>

      <div className="formik-container__button-container">
        <button type="submit">{language.formComponent.button}</button>
      </div>
      {formSended && (
        <div className="formik-container__success-container">
          <p className="success-msg">{language.formComponent.successMessage}</p>
        </div>
      )}
    </form>
  );
};

export default Form_Component;
